<script setup lang="ts">
import 'element-plus/dist/index.css'
import '@/styles/element/index.css'
import '@/styles/index.css'
import NP from 'number-precision'

NP.enableBoundaryChecking(false)

const userStore = useUserStore()

onMounted(async () => {
  await userStore.boost().catch(() => {
    navigateTo({ path: '/login', replace: true })
  })
  await useSettingStore().boost()
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
